import styled from "styled-components";
import { theme } from "../theme";

const Button = styled.button`
  padding: ${(props) => (props.$size === "sm" ? "6px 12px" : "10px 20px")};
  background: ${(props) => {
    switch (props.$variant) {
      case "primary":
        return theme.colors.accent;
      case "danger":
        return theme.colors.danger;
      case "success":
        return theme.colors.success;
      case "secondary":
        return theme.colors.borderLight;
      case "ghost":
        return "transparent";
      default:
        return theme.colors.accent;
    }
  }};
  color: ${(props) => {
    switch (props.$variant) {
      case "ghost":
        return theme.colors.accent;
      case "secondary":
        return theme.colors.text;
      default:
        return "#fff";
    }
  }};
  border: ${(props) =>
    props.$variant === "ghost"
      ? "none"
      : `1px solid ${
          props.$variant === "secondary" ? theme.colors.border : "transparent"
        }`};
  border-radius: ${(props) => theme.radius.md}px;
  cursor: pointer;
  font-size: ${(props) => (props.$size === "sm" ? "12px" : "14px")};
  font-family: ${theme.fonts.body};
  transition: background 0.2s;
  font-weight: 500;

  &:hover {
    background: ${(props) => {
      switch (props.$variant) {
        case "primary":
          return theme.colors.accentHover;
        case "danger":
          return theme.colors.dangerHover;
        case "success":
          return theme.colors.successHover;
        case "secondary":
          return theme.colors.border;
        case "ghost":
          return theme.colors.borderLight;
        default:
          return theme.colors.accentHover;
      }
    }};
  }

  &:disabled {
    background: ${theme.colors.border} !important;
    cursor: not-allowed;
    color: ${theme.colors.textSecondary} !important;
  }
`;

export default Button;
